<template>
  <div id="app">
    <!-- 菜单 -->
    <Navbar class="hidden-xs"></Navbar>

    <!-- 聊天悬浮球 -->
    <!-- <ChatBtn></ChatBtn> -->

    <!-- 切换中英文 -->
    <LangBtn></LangBtn>

    <!-- 搜索，刷新 -->
    <Header
      class="hidden-md hidden-lg"
      v-show="$store.state.shortName != 'sc'"
    ></Header>

    <!-- <transition :name="transitionName" mode="out-in"> -->
    <router-view />
    <!-- </transition> -->

    <!-- 4个tab -->
    <Footer v-show="$store.state.shortName != 'sc'"></Footer>
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";

import ChatBtn from "./components/ChatBtn";
import LangBtn from "./components/LangBtn";

export default {
  name: "App",
  data() {
    return {
      transitionName: "slide-left",
      chatUrl: function () {
        return myutil.chat_url + "/?token=" + this.$store.state.token;
      },
    };
  },
  mounted() {
    var that = this;
    that.$store.commit("set_ver", "1.4.0");

    myutil.height = window.innerHeight;
    myutil.width = window.innerWidth;

    window.websocket = "";
    this.testDevice();
    this.testUrl();

    var _url = myutil.base_url + "/user/islogin/";
    $.get(_url).done(function (res) {
      var isLogin = myutil.parseJson(res).code == 0 ? true : false;

      var whiteList = [
        "/",
        "Home",
        "BitcoinTrading",
        "IntroMarket",
        "NewsEn",
        "Reg",
        "Login",
        "Search",
        "PwdChange",
        "PwdReset",
        "Trading",
        "Jin10",
      ];

      if (whiteList.includes("IntroMarket")) {
        return;
      } else {
        if (!isLogin) {
          var _url = myutil.base_url + "/user/logout";
          $.get(_url).done(function (res) {
            that.$store.commit("set_isLogin", "");
            that.$store.commit("set_token", "");

            that.$store.commit("set_sideMenu", []);
            that.$store.commit("set_subMenu", []);
            that.$store.commit("set_orderMenu", []);
            that.$store.commit("set_recordPositionMenu", []);

            that.$store.commit("set_userInfo", "");
            that.$store.commit("set_commonInfo", "");
          });
          setTimeout(function () {}, 1);
        }
      }
    });
  },
  watch: {
    // 切换路由和手动刷新
    $route(to, from) {
      var that = this;

      that.$i18n.locale = that.$store.state.langOnPage["other"];

      that.testLanguage(that.$i18n.locale);
      // that.testLanguage(that.$store.state.langOnPage.other);

      var _url = myutil.base_url + "/user/islogin/";
      $.get(_url).done(function (res) {
        var isLogin = myutil.parseJson(res).code == 0 ? true : false;

        var whiteList = [
          "/",
          "Home",
          "BitcoinTrading",
          "IntroMarket",
          "News",
          "NewsEn",
          "Reg",
          "Login",
          "Search",
          "PwdChange",
          "PwdReset",
          "Trading",
          "Jin10",
          "Chat2",
        ];
        if (whiteList.includes(that.$route.name)) {
          return;
        } else {
          if (!isLogin) {
            var _url = myutil.base_url + "/user/logout";
            $.get(_url).done(function (res) {
              that.$store.commit("set_isLogin", "");
              that.$store.commit("set_token", "");

              that.$store.commit("set_sideMenu", []);
              that.$store.commit("set_subMenu", []);
              that.$store.commit("set_orderMenu", []);
              that.$store.commit("set_recordPositionMenu", []);

              that.$store.commit("set_userInfo", "");
              that.$store.commit("set_commonInfo", "");
            });
            setTimeout(function () {
              that.$router.push("/Login");
            }, 1);
          }
        }
      });
    },
  },
  beforeCreate: function () {
    // 刷新页面时
    var that = this;

    that.$i18n.locale = that.$store.state.langOnPage["other"];

    $.ajaxSetup({
      headers: {
        Authorization: that.$store.state.token,
      },
    });
  },
  methods: {
    testDevice: function () {
      function IsPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = [
          "Android",
          "iPhone",
          "SymbianOS",
          "Windows Phone",
          "iPad",
          "iPod",
        ];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      }

      myutil.pcFlag = IsPC(); //true为PC端，false为手机端

      this.$store.commit("set_pcFlag", myutil.pcFlag); //用户信息置入全局
    },
    testUrl: function () {
      var that = this;

      if (window.location.host.search("80") != -1) {
        // 本地开发
        myutil.base_url = "/chy";
        document.getElementsByTagName("title")[0].innerText = "";

        // myutil.base_url = "http://zhengdeziben.com";
        myutil.base_url = "https://jr.skjpt.com"
        // myutil.iframeBaseUrl = "http://zhengdeziben.com";
        myutil.shortName = "eadva";
        myutil.ws_url = "wss://ws.skjpt.com:8443";
        // myutil.areaCode = "84";

          myutil.base_url = "http://trade.eadva.com";
          myutil.iframeBaseUrl = "http://trade.eadva.com";
          myutil.chat_url = "http://chat.skjpt.com";
          myutil.ws_url = "wss://ws.skjpt.com:8443";

        myutil.shortName = "eadva";

        
        myutil.iframeBaseUrl = "https://zhengdeziben.com";
        // myutil.chat_url = "https://chat.zhengdeziben.com";
        // myutil.ws_url = "wss://ws.zhengdeziben.com:8443";
      }

      if (window.location.host.search("mine.starfintex.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://mine.starfintex.com";
          myutil.iframeBaseUrl = "https://mine.starfintex.com";
          myutil.chat_url = "https://chat.starfintex.com";
          myutil.ws_url = "wss://ws.starfintex.com:8443";
        } else {
          myutil.base_url = "http://mine.starfintex.com";
          myutil.iframeBaseUrl = "http://mine.starfintex.com";
          myutil.chat_url = "http://chat.starfintex.com";
          myutil.ws_url = "wss://ws.starfintex.com:8443";
        }

        myutil.shortName = "starfintex";
        document.getElementsByTagName("title")[0].innerText = "";
      }

      if (window.location.host.search("starfintex.k6110.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://starfintex.k6110.com";
          myutil.iframeBaseUrl = "https://starfintex.k6110.com";
          myutil.chat_url = "https://chat.k6110.com";
          myutil.ws_url = "wss://ws.k6110.com:8443";
        } else {
          myutil.base_url = "http://starfintex.k6110.com";
          myutil.iframeBaseUrl = "http://starfintex.k6110.com";
          myutil.chat_url = "http://chat.k6110.com";
          myutil.ws_url = "wss://ws.k6110.com:8443";
        }

        myutil.shortName = "starfintex";
        document.getElementsByTagName("title")[0].innerText = "";
      }

      if (window.location.host.search("newxl.k6110.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://newxl.k6110.com";
          myutil.iframeBaseUrl = "https://newxl.k6110.com";
          myutil.chat_url = "https://chat.k6110.com";
          myutil.ws_url = "wss://ws.k6110.com:8443";
        } else {
          myutil.base_url = "http://newxl.k6110.com";
          myutil.iframeBaseUrl = "http://newxl.k6110.com";
          myutil.chat_url = "http://chat.k6110.com";
          myutil.ws_url = "wss://ws.k6110.com:8443";
        }

        myutil.shortName = "newxl";
        document.getElementsByTagName("title")[0].innerText = "";
      }

      if (window.location.host.search("jr.skjpt.com") != -1) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://jr.skjpt.com";
          myutil.iframeBaseUrl = "https://jr.skjpt.com";
          myutil.chat_url = "https://chat.skjpt.com";
          myutil.ws_url = "wss://ws.skjpt.com:8443";
        } else {
          myutil.base_url = "http://jr.skjpt.com";
          myutil.iframeBaseUrl = "http://jr.skjpt.com";
          myutil.chat_url = "http://chat.skjpt.com";
          myutil.ws_url = "wss://ws.skjpt.com:8443";
        }

        myutil.shortName = "jr";
        document.getElementsByTagName("title")[0].innerText = "";
      }

      //--------------marketcoinvn------mc-------------越南
      if (window.location.host.search("marketcoinvn.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://marketcoinvn.com";
          myutil.iframeBaseUrl = "https://marketcoinvn.com";
          myutil.chat_url = "https://chat.marketcoinvn.com";
          myutil.ws_url = "wss://ws.marketcoinvn.com:8443";
        } else {
          myutil.base_url = "http://marketcoinvn.com";
          myutil.iframeBaseUrl = "http://marketcoinvn.com";
          myutil.chat_url = "http://chat.marketcoinvn.com";
          myutil.ws_url = "wss://ws.marketcoinvn.com:8443";
        }

        myutil.shortName = "mc";
        myutil.areaCode = "84"; //地区代码  泰国66 印度91 马来西亚60 越南84 中国86
        document.getElementsByTagName("title")[0].innerText = "";
      }

      if (window.location.host.search("www.marketcoinvn.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://www.marketcoinvn.com";
          myutil.iframeBaseUrl = "https://www.marketcoinvn.com";
          myutil.chat_url = "https://chat.marketcoinvn.com";
          myutil.ws_url = "wss://ws.marketcoinvn.com:8443";
        } else {
          myutil.base_url = "http://www.marketcoinvn.com";
          myutil.iframeBaseUrl = "http://www.marketcoinvn.com";
          myutil.chat_url = "http://chat.marketcoinvn.com";
          myutil.ws_url = "wss://ws.marketcoinvn.com:8443";
        }

        myutil.shortName = "mc";
        myutil.areaCode = "84"; //地区代码  泰国66 印度91 马来西亚60 越南84 中国86
        document.getElementsByTagName("title")[0].innerText = "";
      }

      //--------------sc-------------------简化
      if (window.location.host.search("supercoinvn.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://supercoinvn.com";
          myutil.iframeBaseUrl = "https://supercoinvn.com";
          myutil.chat_url = "https://chat.supercoinvn.com";
          myutil.ws_url = "wss://ws.supercoinvn.com:8443";
        } else {
          myutil.base_url = "http://supercoinvn.com";
          myutil.iframeBaseUrl = "http://supercoinvn.com";
          myutil.chat_url = "http://chat.supercoinvn.com";
          myutil.ws_url = "wss://ws.supercoinvn.com:8443";
        }

        myutil.shortName = "sc";
        document.getElementsByTagName("title")[0].innerText = "";
      }

      if (window.location.host.search("www.supercoinvn.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://www.supercoinvn.com";
          myutil.iframeBaseUrl = "https://www.supercoinvn.com";
          myutil.chat_url = "https://chat.supercoinvn.com";
          myutil.ws_url = "wss://ws.supercoinvn.com:8443";
        } else {
          myutil.base_url = "http://www.supercoinvn.com";
          myutil.iframeBaseUrl = "http://www.supercoinvn.com";
          myutil.chat_url = "http://chat.supercoinvn.com";
          myutil.ws_url = "wss://ws.supercoinvn.com:8443";
        }

        myutil.shortName = "sc";
        document.getElementsByTagName("title")[0].innerText = "";
      }

      //--------------zd-------------------a股
      if (window.location.host.search("zhengdaziben.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://zhengdaziben.com";
          myutil.iframeBaseUrl = "https://zhengdaziben.com";
          myutil.chat_url = "https://chat.zhengdaziben.com";
          myutil.ws_url = "wss://ws.zhengdaziben.com:8443";
        } else {
          myutil.base_url = "http://zhengdaziben.com";
          myutil.iframeBaseUrl = "http://zhengdaziben.com";
          myutil.chat_url = "http://chat.zhengdaziben.com";
          myutil.ws_url = "wss://ws.zhengdaziben.com:8443";
        }

        myutil.shortName = "zd";
        document.getElementsByTagName("title")[0].innerText = "";
      }

      if (window.location.host.search("www.zhengdaziben.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://www.zhengdaziben.com";
          myutil.iframeBaseUrl = "https://www.zhengdaziben.com";
          myutil.chat_url = "https://chat.zhengdaziben.com";
          myutil.ws_url = "wss://ws.zhengdaziben.com:8443";
        } else {
          myutil.base_url = "http://www.zhengdaziben.com";
          myutil.iframeBaseUrl = "http://www.zhengdaziben.com";
          myutil.chat_url = "http://chat.zhengdaziben.com";
          myutil.ws_url = "wss://ws.zhengdaziben.com:8443";
        }

        myutil.shortName = "zd";

        document.getElementsByTagName("title")[0].innerText = "";
      }

      if (window.location.host.search("www.zhengdeziben.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://www.zhengdeziben.com";
          myutil.iframeBaseUrl = "https://www.zhengdeziben.com";
          myutil.chat_url = "https://chat.zhengdeziben.com";
          myutil.ws_url = "wss://ws.zhengdeziben.com:8443";
        } else {
          myutil.base_url = "http://www.zhengdeziben.com";
          myutil.iframeBaseUrl = "http://www.zhengdeziben.com";
          myutil.chat_url = "http://chat.zhengdeziben.com";
          myutil.ws_url = "wss://ws.zhengdeziben.com:8443";
        }

        myutil.shortName = "zd";

        document.getElementsByTagName("title")[0].innerText = "";
      }

      if (window.location.host.search("zhengdeziben.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://zhengdeziben.com";
          myutil.iframeBaseUrl = "https://zhengdeziben.com";
          myutil.chat_url = "https://chat.zhengdeziben.com";
          myutil.ws_url = "wss://ws.zhengdeziben.com:8443";
        } else {
          myutil.base_url = "http://zhengdeziben.com";
          myutil.iframeBaseUrl = "http://zhengdeziben.com";
          myutil.chat_url = "http://chat.zhengdeziben.com";
          myutil.ws_url = "wss://ws.zhengdeziben.com:8443";
        }

        myutil.shortName = "zd";

        document.getElementsByTagName("title")[0].innerText = "";
      }

      if (window.location.host.search("jr.skjpt.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://jr.skjpt.com";
          myutil.iframeBaseUrl = "https://jr.skjpt.com";
          myutil.chat_url = "https://chat.skjpt.com";
          myutil.ws_url = "wss://ws.skjpt.com:8443";
        } else {
          myutil.base_url = "http://jr.skjpt.com";
          myutil.iframeBaseUrl = "http://skjpt.com";
          myutil.chat_url = "http://chat.skjpt.com";
          myutil.ws_url = "wss://ws.skjpt.com:8443";
        }

        myutil.shortName = "sk";

        document.getElementsByTagName("title")[0].innerText = "";
      }

      if (window.location.host.search("trade.eadva.com") == 0) {
        if (window.location.protocol == "https:") {
          myutil.base_url = "https://trade.eadva.com";
          myutil.iframeBaseUrl = "https://trade.eadva.com";
          myutil.chat_url = "https://chat.skjpt.com";
          myutil.ws_url = "wss://ws.skjpt.com:8443";
        } else {
          myutil.base_url = "http://trade.eadva.com";
          myutil.iframeBaseUrl = "http://trade.eadva.com";
          myutil.chat_url = "http://chat.skjpt.com";
          myutil.ws_url = "wss://ws.skjpt.com:8443";
        }

        myutil.shortName = "eadva";

        document.getElementsByTagName("title")[0].innerText = "";
      }

      // https://jr.skjpt.com

      myutil.appSourceUrl = myutil.base_url + "/AppSource/";

      if (myutil.shortName == "mc") {
        // myutil.thirdChatUrl =
        //   "https://chat.bce8.com/index.php/chat/start/(department)/5";

        if (!that.$store.state.langOnPage["other"]) {
          that.$store.commit("set_langOnPage", {
            IntroMarket: "en", // 首页
            other: "vi",
          });
        }

        that.$store.commit("setData", {
          key: "touristChat",
          value: "https://t.me/marketcoinvn",
        });
      }

      if (myutil.shortName == "zd") {
        // myutil.thirdChatUrl =
        //   "http://chat.bce8.com/index.php/chn/chat/start/(department)/4";
      }

      that.$store.commit("setData", {
        key: "shortName",
        value: myutil.shortName,
      });

      // myutil.tvWssUrl = 'wss://' + myutil.base_url.split('//')[1] + ':8443'
      myutil.tvWssUrl = 'wss://financeapi.skjpt.com:8443'

      that.$store.commit("setData", {
        key: "pageConfig",
        value: myutil,
      });

      if (myutil.shortName != "zd") {
        (function () {
          var link = document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = "./static/1stffc.ico";
          document.getElementsByTagName("head")[0].appendChild(link);
        })();
      }

      if (myutil.shortName == "zd") {
        (function () {
          var link = document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = "./static/zd.png";
          document.getElementsByTagName("head")[0].appendChild(link);
        })();
      }

      // that.$store.commit("set_langOnPage", {
      //     IntroMarket: "en", // 首页
      //     other: that.$store.state.langOnPage["other"],
      //   });

      // that.$i18n.locale = that.$store.state.langOnPage["other"];

      // that.testLanguage(that.$i18n.locale);
    },
    testLocate: function () {
      var type = navigator.appName;
      if (type == "Netscape") {
        var lang = navigator.language; //获取浏览器配置语言，支持非IE浏览器
      } else {
        var lang = navigator.userLanguage; //获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
      }
      var lang = lang.substr(0, 2); //获取浏览器配置语言前两位

      if (lang == "zh") {
        this.$i18n.locale = "zh";
      } else {
        this.$i18n.locale = "en";
      }

      //  myutil.i18n = "en";

      // this.$i18n.locale = myutil.i18n;

      for (var item in this.$store.state.langOnPage) {
        console.log(item);
        this.$store.state.langOnPage[item] = "zh";
      }
      this.$store.state.langOnPage["IntroMarket"] = "en";
    },
    testLanguage: function (lang) {

      if (window.location.href.indexOf("?") > -1) {
        var theme = window.location.href.split("?")[1].split("&");

        var temp = {};

        theme.forEach(function (value, index) {
          var k = value.split("=")[0];
          var v = value.split("=")[1];

          temp[k] = v;
        });

        console.log("检测参数lang", temp);
        if(temp.hasOwnProperty('lang')){
          this.$i18n.locale = temp.lang
        }
         
      }


      if (lang == "vi") {
        (function ($) {
          $.fn.bootstrapTable.locales["vi-VN"] = {
            formatLoadingMessage: function formatLoadingMessage() {
              return "Đang tải...";
            },
            formatRecordsPerPage: function formatRecordsPerPage(pageNumber) {
              return pageNumber + " b\u1EA3n ghi m\u1ED7i trang";
            },
            formatShowingRows: function formatShowingRows(
              pageFrom,
              pageTo,
              totalRows
            ) {
              return (
                "Hi\u1EC3n th\u1ECB t\u1EEB trang " +
                pageFrom +
                " \u0111\u1EBFn " +
                pageTo +
                " c\u1EE7a " +
                totalRows +
                " b\u1EA3ng ghi"
              );
            },
            formatSearch: function formatSearch() {
              return "Tìm kiếm";
            },
            formatNoMatches: function formatNoMatches() {
              return "Không có dữ liệu";
            },
          };

          $.extend(
            $.fn.bootstrapTable.defaults,
            $.fn.bootstrapTable.locales["vi-VN"]
          );
        })(jQuery);

        (function (a) {
          a.fn.datepicker.dates.vi = {
            days: [
              "Chủ nhật",
              "Thứ hai",
              "Thứ ba",
              "Thứ tư",
              "Thứ năm",
              "Thứ sáu",
              "Thứ bảy",
            ],
            daysShort: [
              "CN",
              "Thứ 2",
              "Thứ 3",
              "Thứ 4",
              "Thứ 5",
              "Thứ 6",
              "Thứ 7",
            ],
            daysMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
            months: [
              "Tháng 1",
              "Tháng 2",
              "Tháng 3",
              "Tháng 4",
              "Tháng 5",
              "Tháng 6",
              "Tháng 7",
              "Tháng 8",
              "Tháng 9",
              "Tháng 10",
              "Tháng 11",
              "Tháng 12",
            ],
            monthsShort: [
              "Th1",
              "Th2",
              "Th3",
              "Th4",
              "Th5",
              "Th6",
              "Th7",
              "Th8",
              "Th9",
              "Th10",
              "Th11",
              "Th12",
            ],
            today: "Hôm nay",
            clear: "Xóa",
            format: "yyyy-mm-dd",
          };
        })(jQuery);
      }

      if (lang == "zh") {
        (function ($) {
          $.fn.bootstrapTable.locales["zh-CN"] = {
            formatLoadingMessage: function formatLoadingMessage() {
              return "正在努力地加载数据中，请稍候……";
            },
            formatRecordsPerPage: function formatRecordsPerPage(pageNumber) {
              return (
                "\u6BCF\u9875\u663E\u793A " + pageNumber + " \u6761\u8BB0\u5F55"
              );
            },
            formatShowingRows: function formatShowingRows(
              pageFrom,
              pageTo,
              totalRows
            ) {
              return (
                "\u663E\u793A\u7B2C " +
                pageFrom +
                " \u5230\u7B2C " +
                pageTo +
                " \u6761\u8BB0\u5F55\uFF0C\u603B\u5171 " +
                totalRows +
                " \u6761\u8BB0\u5F55"
              );
            },
            formatSearch: function formatSearch() {
              return "搜索";
            },
            formatNoMatches: function formatNoMatches() {
              return "没有找到匹配的记录";
            },
            formatPaginationSwitch: function formatPaginationSwitch() {
              return "隐藏/显示分页";
            },
            formatRefresh: function formatRefresh() {
              return "刷新";
            },
            formatToggle: function formatToggle() {
              return "切换";
            },
            formatColumns: function formatColumns() {
              return "列";
            },
            formatExport: function formatExport() {
              return "导出数据";
            },
            formatClearFilters: function formatClearFilters() {
              return "清空过滤";
            },
          };

          $.extend(
            $.fn.bootstrapTable.defaults,
            $.fn.bootstrapTable.locales["zh-CN"]
          );
        })(jQuery);

        (function (a) {
          a.fn.datepicker.dates["zh"] = {
            days: [
              "星期日",
              "星期一",
              "星期二",
              "星期三",
              "星期四",
              "星期五",
              "星期六",
            ],
            daysShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
            daysMin: ["日", "一", "二", "三", "四", "五", "六"],
            months: [
              "一月",
              "二月",
              "三月",
              "四月",
              "五月",
              "六月",
              "七月",
              "八月",
              "九月",
              "十月",
              "十一月",
              "十二月",
            ],
            monthsShort: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
            today: "今天",
            monthsTitle: "选择月份",
            clear: "清除",
            format: "yyyy-mm-dd",
            titleFormat: "yyyy年mm月",
            weekStart: 1,
          };
        })(jQuery);
      }

      if (lang == "en") {
        (function ($) {
          $.fn.bootstrapTable.locales["en-US"] = {
            formatLoadingMessage: function formatLoadingMessage() {
              return "Loading, please wait...";
            },
            formatRecordsPerPage: function formatRecordsPerPage(pageNumber) {
              return pageNumber + " rows per page";
            },
            formatShowingRows: function formatShowingRows(
              pageFrom,
              pageTo,
              totalRows
            ) {
              return (
                "Showing " +
                pageFrom +
                " to " +
                pageTo +
                " of " +
                totalRows +
                " rows"
              );
            },
            formatSearch: function formatSearch() {
              return "Search";
            },
            formatNoMatches: function formatNoMatches() {
              return "No matching records found";
            },
            formatPaginationSwitch: function formatPaginationSwitch() {
              return "Hide/Show pagination";
            },
            formatRefresh: function formatRefresh() {
              return "Refresh";
            },
            formatToggle: function formatToggle() {
              return "Toggle";
            },
            formatColumns: function formatColumns() {
              return "Columns";
            },
            formatAllRows: function formatAllRows() {
              return "All";
            },
            formatExport: function formatExport() {
              return "Export data";
            },
            formatClearFilters: function formatClearFilters() {
              return "Clear filters";
            },
          };

          $.extend(
            $.fn.bootstrapTable.defaults,
            $.fn.bootstrapTable.locales["en-US"]
          );
        })(jQuery);

        (function (a) {
          a.fn.datepicker.dates["en"] = {
            days: [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ],
            daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            months: [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ],
            monthsShort: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
            today: "Today",
            monthsTitle: "Months",
            clear: "Clear",
            weekStart: 1,
            format: "yyyy-mm-dd",
          };
        })(jQuery);
      }
    },
  },
  components: {
    Header,
    Footer,
    Navbar,
    ChatBtn,
    LangBtn,
  },
};
</script>

<style lang="less">
@keyframes slideInLeft {
  from {
    transform: translate3d(100%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
  to {
    transform: translate3d(0, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
}
@keyframes slideInRight {
  from {
    transform: translate3d(0%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
  to {
    transform: translate3d(-100%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
}
.slide-left-enter-active {
  position: fixed;
  top: 0;
  left: 0%;
  width: 100vw;
  height: 100vh;
  animation: slideInLeft 0.4s linear forwards;
}
.slide-left-leave-active {
  position: fixed;
  top: 0;
  left: 0%;
  width: 100vw;
  height: 100vh;
  animation: slideInRight 0.4s linear forwards;
}
/*向右滑动*/
@keyframes slideOutLeft {
  from {
    transform: translate3d(-100%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
  to {
    transform: translate3d(0%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
}
@keyframes slideOutRight {
  from {
    transform: translate3d(0%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
  to {
    transform: translate3d(100%, 0, 0);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 1;
  }
}
.slide-right-enter-active {
  position: fixed;
  top: 0;
  left: 0%;
  width: 100vw;
  height: 100vh;
  animation: slideOutLeft 0.4s linear forwards;
}
.slide-right-leave-active {
  position: fixed;
  top: 0;
  left: 0%;
  width: 100vw;
  height: 100vh;
  animation: slideOutRight 0.4s linear forwards;
}
.hand {
  cursor: pointer;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // background: #f8f8f8;
}

.nopadding {
  padding: 0 important;
}

.pull-right.pagination-detail .pagination-info {
  display: none;
}

.bootstrap-table .search {
  width: 90px;
}

.el-transfer-panel .el-checkbox__inner {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  margin-left: -30px;
}

.dropdown-menu {
  left: -100px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.main-body {
  padding-top: 50px;
  padding-bottom: 50px;
  overflow-x: auto;
  overflow-y: auto;
}

.main-body::after {
  display: block;
  height: 50px;
}

#toolbar {
  position: relative;
  top: -1px;
}
p.total {
  position: relative;
  top: 45px;
  left: 15px;
  font-weight: bold;
}
input.datepicker {
  text-indent: 0.5em;
}

.dropdown-menu {
  left: -100px;
}

div.BtableBox {
  // width: 100%;
  // overflow-y: visible;
  // height: 100%;
  // overflow-x: scroll;
}

div.tableBox {
  // min-height: 300px;
  width: 100%;
  overflow-y: visible;
  height: 100%;
  overflow-x: scroll;
  table {
    border-collapse: collapse;
    tr {
      height: 40px;
      &:nth-child(odd) {
        background-color: #fafafa;
      }
      &:first-child {
        background-color: #eef1f6;
      }
      &:hover {
        background-color: #eef1f6;
      }
    }
    th,
    td {
      border: 1px solid #dfe6ec;
      padding: 8px;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue